import { useAuth } from '../../components/LoginGate';

// Returns the list of product IDs the current user has access to.
// Backend-provided suiteIds are the source of truth.
export function useProducts() {
  const { user } = useAuth();
  if (!user) return [];
  const suiteIds = Array.isArray(user.suiteIds) ? user.suiteIds : [];
  const normalized = [];

  if (suiteIds.includes('core')) normalized.push('core');
  if (suiteIds.includes('re_suite')) normalized.push('re_suite');

  // Backwards compatibility for older auth payloads that only expose packages.
  if (normalized.length === 0) {
    if (user.packages?.includes('re_suite')) return ['re_suite'];
    return ['core'];
  }

  return normalized;
}
